import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { SelectField } from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useAssignDispatcher from '../../../hooks/dispatch/useAssignDispatcher';
import {
    DispatcherAssignDataType, DispatcherAssignInitialValues, DispatcherAssignSchema
} from '../../../models/dispatcher/dispatcherAssign.model';
import { useAppSelector } from '../../../redux/store';
import { getDispatcherId } from '../../../utils/utils';

interface IAssignDispatcherModal {
  tdata: any;
}

const AssignDispatcherModal: React.FC<IAssignDispatcherModal> = ({ tdata }) => {
  const { assignDispatcher, loading } = useAssignDispatcher();
  const { dispatcherList } = useAppSelector((state) => state.dispatcher);

  const onSubmit = (values: DispatcherAssignDataType, actions: any) => {
    const dispatcherId = getDispatcherId(
      dispatcherList,
      values.dispatcher.split(' ')[1]
    );
    assignDispatcher({ dispatcherId, picklistId: tdata.id });

    actions.resetForm(DispatcherAssignInitialValues);
  };

  return (
    <ModalContentWrapper title={'Assign Dispatcher'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={DispatcherAssignInitialValues}
          schema={DispatcherAssignSchema}
          onSubmit={onSubmit}
        >
          <SelectField label="Dispatcher" name="dispatcher">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Dispatcher'}
            </option>
            {dispatcherList.map((data, index) => (
              <option
                key={index}
              >{`${data.lastName} ${data.firstName}`}</option>
            ))}
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Assign Dispatcher
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default AssignDispatcherModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
